module.exports = __webpack_public_path__ + "img/house.f8cf65de.svg";